const AI_SKILL_ACCESS_FLOW_URL =
  'https://flow-runner.api.codelos.io/v9/run_flow_by_id?id=1783659854262';

let cachedAllowedUsers = null;
let accessRequestPromise = null;

const normalizeUserList = (rawUsers) => {
  if (!rawUsers) return [];

  let users = rawUsers;
  if (typeof users === 'string') {
    const trimmed = users.trim();
    if (!trimmed) return [];
    try {
      users = JSON.parse(trimmed);
    } catch (error) {
      users = trimmed.split(',').map((entry) => entry.trim());
    }
  }

  if (!Array.isArray(users)) return [];

  return users
    .map((entry) => {
      if (typeof entry === 'string') return entry.trim().toLowerCase();
      if (entry && typeof entry === 'object') {
        const candidate =
          entry.email || entry.user || entry.username || entry.value || '';
        return String(candidate).trim().toLowerCase();
      }
      return '';
    })
    .filter(Boolean);
};

const fetchAllowedUsers = async () => {
  if (Array.isArray(cachedAllowedUsers)) {
    return cachedAllowedUsers;
  }

  if (accessRequestPromise) {
    return accessRequestPromise;
  }

  accessRequestPromise = (async () => {
    try {
      const response = await fetch(AI_SKILL_ACCESS_FLOW_URL, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        cachedAllowedUsers = [];
        return cachedAllowedUsers;
      }

      const responseData = await response.json();
      const rows = Array.isArray(responseData) ? responseData : [];
      const usersRow = rows.find((row) => String(row?.name || '') === 'users');
      cachedAllowedUsers = normalizeUserList(usersRow?.value);
      return cachedAllowedUsers;
    } catch (error) {
      cachedAllowedUsers = [];
      return cachedAllowedUsers;
    } finally {
      accessRequestPromise = null;
    }
  })();

  return accessRequestPromise;
};

export const checkAISkillAccessForEmail = async (email = '') => {
  const normalizedEmail = String(email || '')
    .trim()
    .toLowerCase();
  if (!normalizedEmail) return false;

  const allowedUsers = await fetchAllowedUsers();
  return allowedUsers.includes(normalizedEmail);
};
